export default function (lote) {
  let window = 'extrato-arrematacao'
  !this.$uloc.printView.get(window) && this.$uloc.printView.new({
    wid: window,
    title: 'Extrato de Arrematação',
    windowClass: 'erp-print',
    contentClass: '',
    props: {
      lote: lote
    }
  }, () => import('@/components/pda/print/views/ExtratoArrematacao'))
    .then((wid) => {
    }) // return wid
}
